import type { EditorSection, FieldSpec } from './types';

const A023 = 'IdVrfctnReq';
const A024 = 'IdVrfctnRpt';

export const ACMT023_FIELDS: FieldSpec[] = [
  {
    key: 'xmlns',
    xmlSelectors: ['Document@xmlns'],
    labelKey: 'try.fieldXmlns',
    defKey: 'try.defXmlns',
    kind: 'text',
    expertOnly: true,
  },
  {
    key: 'assignmentId',
    xmlSelectors: [`${A023}/Assgnmt/MsgId`, `${A024}/OrgnlAssgnmt/MsgId`],
    labelKey: 'try.camt.fieldAssignmentId',
    defKey: 'try.acmt.defAssignmentId',
    kind: 'text',
  },
  {
    key: 'vrfId',
    xmlSelectors: [`${A023}/Vrfctn/Id`, `${A024}/Rpt/OrgnlId`],
    labelKey: 'try.acmt.fieldVrfId',
    defKey: 'try.acmt.defVrfId',
    kind: 'text',
  },
  {
    key: 'createdAt',
    xmlSelectors: [`${A023}/Assgnmt/CreDtTm`, `${A024}/Assgnmt/CreDtTm`],
    labelKey: 'try.fieldCreatedAt',
    defKey: 'try.defCreatedAt',
    kind: 'datetime',
  },
  {
    key: 'assignorBic',
    xmlSelectors: [`${A023}/Assgnmt/Assgnr/Agt/FinInstnId/BICFI`, `${A024}/Assgnmt/Assgne/Agt/FinInstnId/BICFI`],
    labelKey: 'try.camt.fieldAssignorBic',
    defKey: 'try.acmt.defAssignorBic',
    kind: 'text',
  },
  {
    key: 'assigneeBic',
    xmlSelectors: [`${A023}/Assgnmt/Assgne/Agt/FinInstnId/BICFI`, `${A024}/Assgnmt/Assgnr/Agt/FinInstnId/BICFI`],
    labelKey: 'try.camt.fieldAssigneeBic',
    defKey: 'try.acmt.defAssigneeBic',
    kind: 'text',
  },
  {
    key: 'creditorName',
    xmlSelectors: [`${A023}/Vrfctn/PtyAndAcctId/Pty/Nm`, `${A024}/Rpt/OrgnlPtyAndAcctId/Pty/Nm`],
    labelKey: 'try.fieldCreditorName',
    defKey: 'try.acmt.defCreditorName',
    kind: 'text',
  },
  {
    key: 'creditorIban',
    xmlSelectors: [`${A023}/Vrfctn/PtyAndAcctId/Acct/Id/IBAN`, `${A024}/Rpt/OrgnlPtyAndAcctId/Acct/Id/IBAN`],
    labelKey: 'try.fieldCreditorIban',
    defKey: 'try.acmt.defCreditorIban',
    kind: 'text',
  },
  {
    key: 'reportId',
    xmlSelectors: [`${A024}/Assgnmt/MsgId`],
    labelKey: 'try.acmt.fieldReportId',
    defKey: 'try.acmt.defReportId',
    kind: 'text',
    expertOnly: true,
    simpleAlias: 'assignmentId',
  },
  {
    key: 'updatedName',
    xmlSelectors: [`${A024}/Rpt/UpdtdPtyAndAcctId/Pty/Nm`],
    labelKey: 'try.acmt.fieldUpdatedName',
    defKey: 'try.acmt.defUpdatedName',
    kind: 'text',
    expertOnly: true,
  },
  {
    key: 'reasonCode',
    xmlSelectors: [`${A024}/Rpt/Rsn/Cd`],
    labelKey: 'try.acmt.fieldReasonCode',
    defKey: 'try.acmt.defReasonCode',
    kind: 'select',
    expertOnly: true,
    options: ['CMTC', 'NMTC', 'NOAP'],
  },
  {
    key: 'outcome',
    xmlSelectors: [`${A024}/Rpt/Vrfctn`],
    labelKey: 'try.acmt.outcome',
    defKey: 'try.acmt.outcomeDef',
    kind: 'select',
    options: ['MTCH', 'NMTC'],
  },
];

export const ACMT023_SIMPLE_SECTIONS: EditorSection[] = [
  { id: 'ids', titleKey: 'try.sectionIds', keys: ['assignmentId', 'vrfId'], columns: 2 },
  { id: 'banks', titleKey: 'try.camt.sectionBanks', keys: ['assignorBic', 'assigneeBic'], columns: 2 },
  {
    id: 'party',
    titleKey: 'try.acmt.sectionParty',
    keys: ['creditorName', 'creditorIban'],
  },
  { id: 'timing', titleKey: 'try.sectionTiming', keys: ['createdAt'] },
];

export const ACMT023_EXPERT_SECTIONS: EditorSection[] = [
  { id: 'document', titleKey: 'try.sectionDocument', keys: ['xmlns'] },
  {
    id: 'assignment',
    titleKey: 'try.camt.sectionAssignment',
    keys: ['assignmentId', 'vrfId', 'reportId', 'createdAt', 'assignorBic', 'assigneeBic'],
    columns: 2,
  },
  {
    id: 'party',
    titleKey: 'try.acmt.sectionParty',
    keys: ['creditorName', 'creditorIban', 'updatedName'],
  },
  {
    id: 'status',
    titleKey: 'try.acmt.sectionReport',
    keys: ['outcome', 'reasonCode'],
    columns: 2,
  },
];
